import CrashdownData from 'CrashdownData'
import * as React from 'react'
import { Elements, StripeProvider } from 'react-stripe-elements'
import { IProps as IOriginalProps } from '../Checkout/MembershipCheckoutForm'
import { ThreeYearCheckout } from './components/ThreeYearCheckout'

class WrappedThreeYearCheckout extends React.Component<IOriginalProps, {}> {
  public render() {
    return (
      <StripeProvider apiKey={CrashdownData.stripe.publishableKey}>
        <Elements>
          <ThreeYearCheckout {...this.props} />
        </Elements>
      </StripeProvider>
    )
  }
}

export { WrappedThreeYearCheckout as ThreeYearCheckout }
